import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"item-value":"id","item-text":"long_name","items":_vm.divisionList,"label":_vm.label !== undefined ? _vm.label || 'Division' : undefined,"rules":_vm.rules,"hide-details":_vm.hideDetails,"dense":_vm.dense,"value":_vm.value,"return-object":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }